<template>
    <validation-observer ref="form" v-slot="{ meta }">
        <modal
            :id="modalId"
            :title="modalTitle"
            ok-title="Save"
            :ok-disabled="!meta.valid"
            @show="fetchPackages"
            @hidden="clearData"
            @shown="setData"
            scrollable
            @ok.prevent="createdEditModule"
        >
            <div>
                <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required" >
                    <form-input v-model="formObject.name" label="Name:" :error="errors[0]" @input="handleChange">
                    </form-input>
                </validation-provider>
                <validation-provider name="package" v-slot="{ errors }" >
                    <form-select
                        v-model="formObject.package_id"
                        :options="packagesList"
                        label="Package:"
                        :error="errors[0]"
                    ></form-select>
                </validation-provider>
                <form-textarea v-model="formObject.description" label="Description:"></form-textarea>
                <validation-provider
                    name="amount"
                    v-slot="{ errors, handleChange }"
                    rules="validFloat|required"
                    
                >
                    <form-input v-model="formObject.amount" label="Amount:" :error="errors[0]" @input="handleChange">
                    </form-input>
                </validation-provider>
                <div>
                    <validation-provider name="status" v-slot="{ errors, handleChange }" rules="required" >
                        <form-select
                            v-model="formObject.status"
                            :options="statusOptions"
                            label="Status:"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-select>
                    </validation-provider>
                    <span class="small text-secondary">
                        Active = Displayed as option to property owners. Inactive = Not displayed to property owners.
                        Disabled = Disabled.
                    </span>
                </div>
                <div>
                    <form-select
                        class="mt-2"
                        v-model="formObject.component"
                        :options="componentOptions"
                        label="Component:"
                    ></form-select>
                    <span class="small text-secondary">
                        Choose a component if you wish to create a custom module for existing application logic. Leave
                        blank otherwise.
                    </span>
                </div>
            </div>
        </modal>
    </validation-observer>
</template>

<script>
import Modal from '../generic/modal/modal.vue';
import FormInput from '../generic/form-input/form-input.vue';
import FormSelect from '../generic/form-select/form-select.vue';
import FormTextarea from '../generic/form-textarea/form-textarea.vue';
import API from '../../api';
import { PACKAGES_LIST_ENDPOINT } from '../../endpoints';

export default {
    components: {
        Modal,
        FormInput,
        FormSelect,
        FormTextarea,
    },
    props: {
        modalId: String,
        modalTitle: String,
        packages: {
            type: Array,
            default: () => [],
        },
        packageData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            packagesList: [],
            formObject: {
                name: null,
                package_id: null,
                description: null,
                status: null,
                component: null,
                amount: null,
            },
        };
    },
    created() {
        this.formObject = this.packageData
            ? { ...this.packageData }
            : {
                  name: null,
                  package_id: null,
                  description: null,
                  status: null,
                  component: null,
                  amount: null,
              };
    },
    computed: {
        statusOptions() {
            return [
                { text: 'Active', value: 'ACTIVE' },
                { text: 'Inactive', value: 'INACTIVE' },
                { text: 'Disabled', value: 'DISABLED' },
            ];
        },
        componentOptions() {
            return [
                { text: '---------', value: '' },
                { text: 'QuickBooks', value: 'quickbooks' },
                { text: 'Property Management', value: 'owners' },
                { text: 'Website Maintenance', value: 'website' },
            ];
        },
    },
    methods: {
        clearData() {
            if (!this.packageData.name) {
                this.formObject = {
                    name: null,
                    package_id: null,
                    description: null,
                    status: null,
                    component: null,
                    amount: null,
                };
            }
        },
        setData() {
            this.$refs.form.setValues(this.formObject);
        },
        createdEditModule() {
            this.$emit('submit', this.formObject);
        },
        async fetchPackages() {
            try {
                const response = await API.get(PACKAGES_LIST_ENDPOINT());
                this.packagesList = [
                    { value: null, text: '---------' },
                    ...response.data.map((item) => ({
                        text: item.name,
                        value: item.id,
                    })),
                ];
                this.formObject.package_id = this.packageData.package_id
                    ? this.packageData.package_id
                    : this.packagesList[0].value;
                this.formObject.component = this.packageData.component
                    ? this.packageData.component
                    : this.componentOptions[0].value;
            } catch (e) {
                this.errorToast({ text: 'Could not load packages' });
            }
        },
    },
};
</script>
